###*
  * Implements parsing hash and form to settings object, rendering settings object to hash and form
  * Used by SettingsManager
###

class INTENT.report.SettingsParser

  constructor: (@parent) ->
    @code = @parent.code + '-parser'
    @attr = @parent.attr + '-parser'
    @controller = @parent.controller

  render_form: (settings) =>
    @parent.set_dataset settings.dataset_name
    @parent.set_grouping settings.keys
    @parent.set_timezone settings.timezone
    if settings.order?
      @parent.set_order settings.order.key, settings.order.direction

    if settings.start? and settings.end?
      @parent.set_dates settings.start, settings.end
    else if settings.period?
      @parent.set_period settings.period

    dataset = @controller.get_dataset()
    for key, item of settings.filters
      if item.key and (item.key in dataset.key_fields or item.key in @controller.get_fields_by_preset())
        type = if item.type is 'filter' then 'key' else 'value'
        @parent.add_filter type, item.key, item.condition, item.values

  parse_form: () =>
    settings = {
      dataset_name: @controller.get_dataset_code()
    }

    if grouping = @parent.get_grouping()
      settings.keys = grouping

    dataset = @controller.get_dataset()
    if dataset.time_enabled
      if dataset.disable_timezone_select
        settings.timezone = dataset.default_timezone
      else if timezone = @parent.get_timezone()
        settings.timezone = timezone

      if dates = @parent.get_dates()
        period = @parent.periodManager.get_period_by_dates dates.start, dates.end
        if 'custom_range' != period
          settings.period = period
        else
          settings.start = dates.start
          settings.end = dates.end

    if filters = @parent.get_filters()
      settings.filters = filters

    if order = @parent.get_order()
      settings.order = order

    hash_fields = @parse_hash().values
    if hash_fields.length
      settings.values = _.intersection dataset.fields, hash_fields

    return settings

  render_hash: (settings) =>
    hash = []

    if settings.dataset_name?
      hash.push "dataset_name=#{settings.dataset_name}"

    if settings.keys?
      hash.push "keys=#{settings.keys.join(',')}"
    if settings.values?
      hash.push "values=#{settings.values.join(',')}"

    if settings.order?
      hash.push "order=#{settings.order.key}/#{settings.order.direction}"

    dataset = @controller.get_dataset()
    if dataset.time_enabled
      if settings.timezone? and !dataset.disable_timezone_select
        hash.push "timezone=#{settings.timezone}"

      if settings.period?
        hash.push "period=#{settings.period}"
      else if settings.start? and settings.end?
        hash.push "start=#{settings.start}"
        hash.push "end=#{settings.end}"

    if _.isArray(settings.filters) and settings.filters.length
      for item in settings.filters
        filter_type = if item.type == 'key' then 'filter' else 'having'
        value = if _.isArray(item.values) then item.values.join(',') else item.values
        hash.push "#{filter_type}=#{item.condition}:#{item.key}:#{encodeURIComponent(decodeURIComponent(value))}"

    hash = hash.join '&'
    @parent.set_watch_hash false
    window.location.hash = hash
    setTimeout (=>
      @parent.set_watch_hash true
    ), 0

  parse_hash: () =>
    settings = {
      filters: []
      keys: [],
      values: []
    }

    dataset = @controller.get_dataset()
    hash = window.location.hash
    hash_parts = hash.replace('#', '').split('&')

    parsed_filters = {}
    for item in hash_parts
      item = item.split('=')
      if _.isArray(item) and item.length is 2
        code = item[0]
        param = item[1]

        if code is 'timezone'
          if dataset.disable_timezone_select
            param = dataset.default_timezone

        if code in ['timezone', 'period', 'start', 'end']
          if dataset.time_enabled is false
            param = ''

        if code in ['keys', 'values']
          param = param.split(',')

        if code in ['order']
          val = param.split('/')
          if val[0]? and val[1]?
            param =
              key: val[0]
              direction: val[1]
          else
            param = undefined

        if code in ['filter', 'having']
          param = param.split(':')
          condition = decodeURIComponent(param[0])
          key = param[1]
          values = (decodeURIComponent(param[2]) || '').split(',')

          if !parsed_filters[code]
            parsed_filters[code] = {}

          # TODO: refactor this
          if key and values and values.length
            if code == 'filter'
              parsed_filters[code][key] = {} if !parsed_filters[code][key]?
              if !parsed_filters[code][key][condition]
                parsed_filters[code][key][condition] = [];
              parsed_filters[code][key][condition] = parsed_filters[code][key][condition].concat values
            else if code == 'having'
              parsed_filters[code][key] = {} if !parsed_filters[code][key]?
              parsed_filters[code][key][condition] = values[0]
        else
          settings[code] = param

    for type, item of parsed_filters
      for key, values of item
        for condition, value of values
          if value.length
            settings.filters.push
              key: key
              type: type
              condition: condition
              values: if _.isArray value then _.uniq value else value

    return settings
